import utils from 'utils';

export default {
  init(store, domEl) {
    const address = domEl.getAttribute('data-address');
    const addressEncoded = utils.locations.getGoogleMapsURL(address);
    domEl.setAttribute('href', addressEncoded);
  },
};
